import axios from "axios";
import qs from "qs";
import { currencyFormatter } from "./dynamic-pricing";

const SCREENPRESSO_PRO = {
  id: "629558D3F2",
  store:
    "https://secure.2checkout.com/checkout/buy?merchant=LEARNPUL&tpl=default&prod=629558D3F2",
};
const SCREENPRESSO_ENTERPRISE = {
  id: "4B1870B5D1",
  store:
    "https://secure.2checkout.com/checkout/buy?merchant=LEARNPUL&tpl=default&prod=4B1870B5D1",
};

const SCREENPRESSO_PRO_RENEWAL = {
  id: "DEFAB97691",
  store:
    "https://secure.2checkout.com/checkout/buy?merchant=LEARNPUL&tpl=default&prod=DEFAB97691",
};

const SCREENPRESSO_ENTERPRISE_RENEWAL = {
  id: "697641F92F",
  store:
    "https://secure.2checkout.com/checkout/buy?merchant=LEARNPUL&tpl=default&prod=697641F92F",
};

export const fetchPrice = product => (
  quantity,
  { reseller, customDiscount = 0, optionCode } = { reseller: false }
) => {

  const uri =
  window.location.hostname === "localhost"
    ? "https://webapi-dev.screenpresso.com/v1/2checkout" // Dev
    : "https://webapi.screenpresso.com/v1/2checkout"; // Prod

  const data = {
    quantity,
    product: product.id,
    optionCode,
  };

  const config = {};

  const discount = reseller ? 0.1 : customDiscount > 0 ? customDiscount : 0;

  return axios
    .get(uri + qs.stringify(data, { addQueryPrefix: true }), config)
    .then(response => {
      const formatCurrency = currencyFormatter(
        response.data.localeCode,
        response.data.currencyCode
      );

      const price = {
        quantity,
        twoCheckout: {
          id: product.id,
        },
        totalWithTax: formatCurrency(
          response.data.grossPriceValue * (1 - discount)
        ),
        totalWithoutTax: formatCurrency(
          response.data.netPriceValue * (1 - discount)
        ),
        totalWithTaxWithoutDiscount: formatCurrency(
          response.data.grossPriceValue + response.data.grossDiscountValue
        ),
        tax: formatCurrency(response.data.taxValue * (1 - discount)),
        isDiscount: (response.data.grossDiscountValue + discount) > 0,
        discountTotal: formatCurrency(
          (response.data.grossPriceValue + response.data.grossDiscountValue)-(response.data.grossPriceValue * (1 - discount))
        ),
        country: response.data.countryCode,
      };

      return price;
    })
    .catch(error => {
      // Do not throw
      console.error(error.message);
      return {};
    });
};

export const fetchProPrice = fetchPrice(SCREENPRESSO_PRO);
export const fetchEnterprisePrice = fetchPrice(SCREENPRESSO_ENTERPRISE);
export const fetchProRenewalPrice = fetchPrice(SCREENPRESSO_PRO_RENEWAL);
export const fetchEnterpriseRenewalPrice = fetchPrice(
  SCREENPRESSO_ENTERPRISE_RENEWAL
);

// Not checkout => contact us will be used instead.
export const enterpriseCheckout = () =>
  "https://secure.2checkout.com/order/checkout.php?PRODS=4613436&QTY=1&CART=1&CARD=1";

export const ProCheckout = (quantity = 1, { voucher } = {}) =>
  `https://secure.2checkout.com/order/checkout.php?PRODS=4537457&QTY=${quantity}&CART=1&CARD=2${voucher?`&COUPON=${voucher}`:""}`;

export const enterpriseRenewalCheckout = (quantity = 1, durationInYears = 1) =>
  `https://secure.2checkout.com/order/checkout.php?PRODS=4721701&QTY=1&CART=1&CARD=1&OPTIONS4721701=SP_RNEW_${durationInYears}_YEARS`;

export const ProRenewalCheckout = (quantity = 1, durationInYears = 1, { voucher } = {}) =>
  `https://secure.2checkout.com/order/checkout.php?PRODS=4717957&QTY=${quantity}&CART=1&CARD=1&OPTIONS4717957=SP_RNEW_${durationInYears}_YEARS${voucher?`&COUPON=${voucher}`:""}`;

// Indicates whether the checkout is an URL or a function to call
export const isProCheckoutUrl = true;


